import { ChipFieldProps, useRecordContext } from 'react-admin';
import { AdjustmentStatus } from 'types/embedded/orderAdjustments';

import { ChipFieldStyled } from './AdjustmentStatusChipField.styled';

export type AdjustmentStatusChipFieldProps = Omit<ChipFieldProps, 'sx'>;

export const AdjustmentStatusChipField = (props: AdjustmentStatusChipFieldProps): JSX.Element => {
  const record = useRecordContext<AdjustmentStatus>();

  if (!record) {
    return <></>;
  }

  return <ChipFieldStyled {...props} status={record.value} />;
};
